/**
 * @file media.ts
 * @description Картинка медиатеки → медиа «вида сайта» (phase19.16 Р1;
 * контракт §0 `Media`: id, адрес, тип, размеры, подпись).
 */

import type { ContentMediaAsset } from "../api-content-media";
import type { SiteMedia } from "./types";

export function toSiteMedia(asset: ContentMediaAsset): SiteMedia {
  return { id: asset.id, url: asset.url, mimeType: asset.mimeType, width: asset.width, height: asset.height, altText: asset.altText };
}
